import { hasAttrSet } from './edit.js'
export default {
	computed: {
		editing_provisioned() {
			return this.state.current_org.id && this.registration.owner_type === 'TempUser'
		}
	},
	methods: {
		PrepareRegFBParams(registration, params) {
			//get the needed entity_attrs and custom_attrs
			const program_blocks = {}
			for (let fp of registration.program.form_parts) {
				for (let fb of fp.form_blocks) {
					program_blocks[fb.id] = fb
				}
			}

			let rfbs_count = registration.registration_form_blocks.length
			for (let i = 0; i < rfbs_count; i++) {
				const obj = registration.registration_form_blocks[i]

				const anyAttr = hasAttrSet(obj, registration)
				// if (!obj.entity_id && !obj.id) continue //skip if new not saved record
				if (!anyAttr) continue //skip if new not saved record
				params.registration_form_blocks_attributes[i] = {
					registration_id: registration.id,
					name: program_blocks[obj.form_block_id].name,
					form_block_id: (obj.form_block_id || null),
					_destroy: (obj._destroy || null),
					id: (obj.id || null),
				};

				if (obj.entity_attrs) {
					params.registration_form_blocks_attributes[i].entity_id = obj.entity_attrs.id
					params.registration_form_blocks_attributes[i].entity_type = obj.entity_type
					params.registration_form_blocks_attributes[i].entity_attrs = { id: obj.entity_attrs.id }
					for (let a of program_blocks[obj.form_block_id].attrs) {
						params.registration_form_blocks_attributes[i].entity_attrs[a] = obj.entity_attrs[a]
					}
					// a little bit spagetti
					if (obj.form_block && obj.form_block.connection_type) {
						params.registration_form_blocks_attributes[i].entity_attrs[obj.form_block.connection_type.type] = obj.form_block.connection_type.name
					}
				}

				params.registration_form_blocks_attributes[i].custom_attrs = {}
				for (let id of program_blocks[obj.form_block_id].custom_field_ids) {
					params.registration_form_blocks_attributes[i].custom_attrs[id] = obj.custom_attrs[id]
				}
				if (obj.member_attrs) params.registration_form_blocks_attributes[i].member_attrs = obj.member_attrs

				registration.registration_form_blocks[i]._destroy = false
				if (!obj.entity_id && !anyAttr) {
					params.registration_form_blocks_attributes[i]._destroy = true
					registration.registration_form_blocks[i]._destroy = true // need to delete later
				}
			}
			if (params.registration_student_transfers_attributes) {
				let rsta_count = registration.registration_student_transfers.length
				for (let i = 0; i < rsta_count; i++) {
					const obj = registration.registration_student_transfers[i]
					params.registration_student_transfers_attributes[i] = obj
				}
			}
			if (params.registration_sending_schools_attributes) {
				let rss_count = registration.registration_sending_schools.length
				for (let i = 0; i < rss_count; i++) {
					const obj = registration.registration_sending_schools[i]
					params.registration_sending_schools_attributes[i] = obj
				}
			}
			if (params.registration_transfer_reasons_attributes) {
				let rtr_count = registration.registration_transfer_reasons.length
				for (let i = 0; i < rtr_count; i++) {
					const obj = registration.registration_transfer_reasons[i]
					params.registration_transfer_reasons_attributes[i] = obj
				}
			}

			if (params.registration_transfer_agreements_attributes) {
				let rta_count = registration.registration_transfer_agreements.length
				for (let i = 0; i < rta_count; i++) {
					const obj = registration.registration_transfer_agreements[i]
					params.registration_transfer_agreements_attributes[i] = obj
				}
			}

			params.registration_transfers_attributes = {
				"0": params.registration_transfers_attributes
			};

			if (window.$reg) {
				for (const fb_id in (window.$reg.temp_rfb || {})) {
					for (const rfb of window.$reg.temp_rfb[fb_id]) {
						rfbs_count++
						params.registration_form_blocks_attributes[rfbs_count] = { ...rfb }
					}
				}
			}

			return params
		}
	},
}
